import * as React from "react";
const SvgFiRrBudgetAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-budget-alt_svg__a)">
      <path
        fill="#062147"
        d="M7.86 13.924c.365-.383.719-.815.993-1.276.431-.727-.14-1.648-.982-1.648H4.13c-.843 0-1.413.921-.982 1.648.273.461.628.894.993 1.276-2.366 1.086-4.14 4.061-4.14 6.587a3.5 3.5 0 0 0 3.5 3.488h5c1.93 0 3.5-1.565 3.5-3.488 0-2.527-1.776-5.501-4.141-6.587M8.5 22h-5c-.827 0-1.5-.667-1.5-1.488C2 18.217 4.168 15.5 6 15.5s4 2.717 4 5.012C10 21.333 9.327 22 8.5 22M21 0H6.499A3.504 3.504 0 0 0 3 3.5V8a1 1 0 0 0 2 0V3.5C5 2.673 5.673 2 6.5 2S8 2.673 8 3.5C8 4.878 9.122 6 10.5 6H19v13c0 1.654-1.346 3-3 3h-2a1 1 0 0 0 0 2h2c2.757 0 5-2.243 5-5V6h.5C22.878 6 24 4.878 24 3.5V3c0-1.654-1.346-3-3-3m1 3.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5c0-.537-.122-1.045-.338-1.5H21c.551 0 1 .449 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-budget-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBudgetAlt;
